module.exports = __webpack_public_path__ + "img/cases-brand-17-cover.1a57d7a9.png";